import actions from "./creditActions";
import getters from "./creditGetters";
import mutations from "./creditMutations";
import state from "./creditState";

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
